import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { CTAButton } from "./CTAButton";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const links = [
    { label: "How it works", id: "how-it-works" },
    { label: "Coming soon", id: "upcoming" },
  ];

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 bg-[#F8F7F3]/95 border-b border-[#171717]/[0.06]"
      data-testid="navbar"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <button
          onClick={() => scrollTo("hero")}
          className="font-heading text-lg md:text-xl font-semibold tracking-tight text-[#171717] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#176B4D] rounded-sm"
          data-testid="nav-logo"
          aria-label="Quantify home"
        >
          QUANTIFY
        </button>

        <nav
          className="hidden md:flex items-center gap-10"
          aria-label="Primary"
        >
          {links.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="text-sm font-medium text-[#171717]/70 hover:text-[#171717] transition-colors duration-200"
              data-testid={`nav-link-${link.id}`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="hidden sm:block">
            <CTAButton
              eventName="hero_cta_click"
              size="sm"
              testId="nav-cta-waitlist"
            />
          </div>
          <button
            className="md:hidden p-2 -mr-2 text-[#171717]"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            data-testid="nav-mobile-toggle"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      <div className="sm:hidden px-6 pb-3 -mt-1">
        <CTAButton
          eventName="hero_cta_click"
          size="sm"
          className="w-full"
          testId="nav-cta-waitlist-mobile"
        />
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: "easeOut" }}
            className="md:hidden overflow-hidden border-t border-[#171717]/[0.06]"
            data-testid="nav-mobile-menu"
          >
            <div className="flex flex-col px-6 py-4 gap-4">
              {links.map((link) => (
                <button
                  key={link.id}
                  onClick={() => {
                    setOpen(false);
                    scrollTo(link.id);
                  }}
                  className="text-left text-base font-medium text-[#171717]/80"
                  data-testid={`nav-mobile-link-${link.id}`}
                >
                  {link.label}
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
